import React from 'react'

import { Button, Icon, Input, useCopyToClipboard } from '@fourthwall/components'
import { TickIcon } from '@fourthwall/icons'

import * as S from './styled'

type CopyLinkInputProps = {
  href: string
  analytics?: string
}

export const CopyLinkInput = ({ analytics, href }: CopyLinkInputProps) => {
  const { isCopied, copyToClipboard } = useCopyToClipboard()

  return (
    <S.Container>
      <S.InputWrapper>
        <Input readOnly size="small" value={href} fullWidth />
      </S.InputWrapper>
      <S.ButtonWrapper>
        <Button
          fullWidth
          appearance="primary"
          label={isCopied ? 'Copied' : 'Copy link'}
          leftIcon={isCopied ? <Icon component={TickIcon} height={16} /> : undefined}
          size="small"
          analytics={analytics}
          disabled={isCopied}
          onClick={() => copyToClipboard(href)}
        />
      </S.ButtonWrapper>
    </S.Container>
  )
}
